const footerItems = document.querySelectorAll('.footer__container-top li');

footerItems.forEach(footerItem => {
  const footerHeader = footerItem.querySelector('.footer__heading');
  const footerMenu = footerItem.querySelector('.footer__menu-list');
  const footerText = footerItem.querySelector('.footer__text');
  const footerSocial = footerItem.querySelector('.footer__list-social');

  if (footerHeader && footerMenu || footerHeader && footerText || footerHeader && footerSocial ) {
    
    footerHeader.addEventListener('click', () => {
      
        footerItem.classList.toggle('open');
        
        footerItems.forEach(otherFooterItem => {
          if (otherFooterItem !== footerItem) {
            otherFooterItem.classList.remove('open');
          }
        });
    });
  }
});